import { Component, OnInit } from '@angular/core';
import { ConnectorService } from './connector.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from '../application/application.service';
declare var $: any;
@Component({
  selector: "app-connector",
  templateUrl: "./connector.component.html",
  styleUrls: ["./connector.component.scss"],
})
export class ConnectorComponent implements OnInit {
  connectorList: [];
  userData: any;
  tabName: string = "Endpoint";
  selectedIndex: number = 0;
  maxNumberOfTabs: number = 7;
  backButtonDisable: boolean = true;
  nextButtonDisable: boolean = false;
  displayNext: string = "block";
  displaySubmit: string = "none";
  displayDone: string = "none";
  displayPrev: string = "block";
  displayAddAnCon: string = "none";
  connectorEndpoint: any;
  connectorTimeout: any;
  connectorName: any;
  connectorIdentifier: any;
  clientId: any;
  clientSecret: any;
  publicKey: any;
  endpointRequiredError: string;
  capabilityRequiredError: string;
  connectorNameRequiredError: string;
  connectorIdentifierRequiredError: string;
  clientIdRequiredError: string;
  clientSecretRequiredError: string;
  timeoutRequiredError: string;
  publicKeyRequiredError: string;
  connectorTypeRequiredError: string;
  capabilities: any;
  deviceCapabilities: any;
  selectedCapabilities = [];
  connectorContent: any;
  selectedConnectorCapabilities = [];
  selectedDeviceCapabilities = [];
  connectorCapabilityRequiredError: string;
  updateendpointRequiredError: string;
  updateWebHookUrlRequiredError: string;
  updateConnectorTypeRequiredError: string;
  updateclientIdRequiredError: string;
  updateclientSecretRequiredError: string;
  updatetimeoutRequiredError: string;
  updatepublicKeyRequiredError: string;
  paramsLength: number = 0;
  paramsArray = [];
  fileData: File = null;
  previewUrl: any = null;
  imageUploaded: boolean = false;
  delconfirmConnector: any;
  loggedUsername: any;
  loadershow: boolean = false;
  clickedItem: any;
  topPosToStartShowing = 100;
  connectorTypes: any = [
    { id: 1, value: "IoT" },
    { id: 2, value: "Messaging" },
    { id: 3, value: "Other" },
  ];
  selectedConnectorType: any;
  usedByApplicationsList: [];
  contentData: string;
  contentData2: string | ArrayBuffer;

  constructor(
    private connectorService: ConnectorService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private applicationService: ApplicationService
  ) {}

  ngOnInit() {
    this.loadershow = true;
    this.userData = JSON.parse(localStorage.getItem("user"));
    this.loggedUsername = localStorage.getItem("name");
    let args = {
      developerId: this.userData.id,
    };
    this.getCapabilities();
    this.getAllConnector(args);
  }

  ngOnDestroy() {
    localStorage.removeItem("connectorDetails");
  }

  getCapabilities() {
    this.connectorService.getCapabilities().subscribe((data) => {
      if (data && data.status == true) {
        this.capabilities = data.info["capabilities"];
        this.deviceCapabilities = data.info["deviceCapabilities"];
      }
    });
  }

  getAllConnector(args) {
    this.connectorService.getAllConnector(args).subscribe((data) => {
      //console.log("---getAllConnector---", data);
      this.loadershow = false;
      if (data && data.status == true) {
        this.connectorList = data.info;
        let connectorSession;
        let getItem = localStorage.getItem("connectorDetails");
        if (getItem != "undefined") {
          connectorSession = JSON.parse(
            localStorage.getItem("connectorDetails")
          );
        }
        if (connectorSession) {
          //console.log('Connector Session')
          this.viewConnectorDetails(connectorSession);
        } else {
          this.viewConnectorDetails(data.info[0]);
        }
      }
    });
  }

  checkScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.gotoTop();
    }
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  checkUpdateRequiredError() {
    if (
      this.connectorCapabilityRequiredError === "" &&
      this.updateendpointRequiredError === "" &&
      this.updateWebHookUrlRequiredError === "" &&
      this.updateConnectorTypeRequiredError === "" &&
      this.updateclientIdRequiredError === "" &&
      this.updateclientSecretRequiredError === "" &&
      this.updatetimeoutRequiredError === "" &&
      this.updatepublicKeyRequiredError === ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  viewConnectorDetails(item) {
    //console.log('xxxxxxxx', item)
    this.loadershow = true;
    this.connectorCapabilityRequiredError = "";
    this.updateendpointRequiredError = "";
    this.updateWebHookUrlRequiredError = "";
    this.updateConnectorTypeRequiredError = "";
    this.updateclientIdRequiredError = "";
    this.updateclientSecretRequiredError = "";
    this.updatetimeoutRequiredError = "";
    this.updatepublicKeyRequiredError = "";
    this.checkScroll();
    if (item) {
      localStorage.setItem("connectorDetails", JSON.stringify(item));
      this.clickedItem = item.name;
    }
    this.paramsArray = [];
    let args = {
      developerId: this.userData.id,
      connectorId: item ? item.id : "",
    };
    this.connectorService.viewConnectorDetails(args).subscribe((data) => {
      this.imageUploaded = false;
      this.loadershow = false;
      if (data && data.status == true) {
        this.connectorContent = data.info;
        this.usedByApplicationsList = [];
        if (this.connectorContent.UsedByApplications > 0) {
          this.connectorService
            .getUsedByApplicationsList(args)
            .subscribe((response) => {
              if (response && response.status == true) {
                this.usedByApplicationsList = response.info;
              }
            });
        }
        this.paramsLength = this.connectorContent["optionalParams"]
          ? Object.keys(this.connectorContent["optionalParams"]).length
          : 0;
        if (this.connectorContent["optionalParams"]) {
          this.paramsArray = Object.entries(
            this.connectorContent["optionalParams"]
          ).map(([key, value]) => ({ key, value }));
        }
        for (let i = this.paramsLength; i < 6; i++) {
          this.paramsArray.push({ key: "", value: "" });
        }
      }
      this.getCapabilities();
    });
  }

  tabChanged(tabChangeEvent) {
    this.selectedIndex = tabChangeEvent.index;
    this.tabName = tabChangeEvent.tab.textLabel;
    if (this.selectedIndex === 7) {
      this.tabName = "Great Success!";
    }
  }

  isUpperCase(myString) {
    var pattern = new RegExp("^(?=.*[A-Z])");
    return !!pattern.test(myString);
  }

  validURL(str) {
    var pattern = new RegExp("^(http|https):[^s]*?"); // fragment locator
    return !!pattern.test(str);
  }

  async nextStep() {
    this.backButtonDisable = false;
    if (this.selectedIndex != this.maxNumberOfTabs) {
      this.selectedIndex = this.selectedIndex + 1;
    }

    if (this.selectedIndex == 1) {
      if (this.connectorEndpoint == "" || this.connectorEndpoint == undefined) {
        this.translate
          .get("Connector.EnterEndpoint")
          .subscribe((res: string) => {
            this.endpointRequiredError = res;
          });
        this.selectedIndex = 0;
      }
      if (this.connectorEndpoint) {
        if (this.validURL(this.connectorEndpoint) == false) {
          this.translate
            .get("Connector.EnterValidURL")
            .subscribe((res: string) => {
              this.endpointRequiredError = res;
            });
          this.selectedIndex = 0;
        } else {
          this.endpointRequiredError = "";
          this.selectedIndex = 1;
        }
      }
    }
    if (this.selectedIndex == 2) {
      if (this.selectedConnectorType === undefined || this.selectedConnectorType == null) {
        this.translate
          .get("Connector.SelectConnectorType")
          .subscribe((res: string) => {
            this.connectorTypeRequiredError = res;
          });
        this.selectedIndex = 1;
      } else {
        this.connectorTypeRequiredError = "";
        this.selectedIndex = 2;
      }
    }

    if (this.selectedIndex == 3) {
      if (
        (this.selectedConnectorType != "IoT" &&
          this.selectedCapabilities.length == 0) ||
        (this.selectedConnectorType == "IoT" &&
          this.selectedDeviceCapabilities.length == 0)
      ) {
        this.translate
          .get("Connector.EnterCapability")
          .subscribe((res: string) => {
            this.capabilityRequiredError = res;
          });
        this.selectedIndex = 2;
      } else {
        this.capabilityRequiredError = "";
        this.selectedIndex = 3;
      }
    }
    if (this.selectedIndex == 4) {
      if (this.connectorTimeout == "" || this.connectorTimeout == undefined) {
        this.translate
          .get("Connector.EnterTimeout")
          .subscribe((res: string) => {
            this.timeoutRequiredError = res;
          });
        this.selectedIndex = 3;
      }
      if (this.connectorTimeout) {
        this.timeoutRequiredError = "";
        this.selectedIndex = 4;
      }
    }
    if (this.selectedIndex == 5) {
      if (this.connectorName == "" || this.connectorName == undefined) {
        this.translate
          .get("Connector.EnterconnectorName")
          .subscribe((res: string) => {
            this.connectorNameRequiredError = res;
          });
        this.selectedIndex = 4;
      } else {
        this.connectorNameRequiredError = "";
      }
      if (
        this.connectorIdentifier == "" ||
        this.connectorIdentifier == undefined
      ) {
        this.translate
          .get("Connector.EnterconnectorIdentifier")
          .subscribe((res: string) => {
            this.connectorIdentifierRequiredError = res;
          });
        this.selectedIndex = 4;
      } else {
        this.connectorIdentifierRequiredError = "";
      }
      if (this.connectorName && this.connectorIdentifier) {
        if (this.isUpperCase(this.connectorIdentifier)) {
          this.translate
            .get("Connector.identifierUppercaseError")
            .subscribe((res: string) => {
              this.connectorIdentifierRequiredError = res;
            });
          this.selectedIndex = 4;
        } else {
          this.selectedIndex = 4;
          let args = {
            developerId: this.userData.id,
            name: this.connectorName,
            scheme: this.connectorIdentifier,
          };
          let data = await this.validateConnectorDetails(args);
          if (data && data.status == false) {
            if (data.info == "scheme_connector_exists") {
              this.translate
                .get("Connector.ConnectorNameExist")
                .subscribe((res: string) => {
                  this.connectorNameRequiredError = res;
                });
              this.translate
                .get("Connector.ConnectorSchemeExist")
                .subscribe((res: string) => {
                  this.connectorIdentifierRequiredError = res;
                });
            }
            if (data.info == "scheme_exists") {
              this.translate
                .get("Connector.ConnectorSchemeExist")
                .subscribe((res: string) => {
                  this.connectorIdentifierRequiredError = res;
                });
            }
            if (data.info == "connector_exists") {
              this.translate
                .get("Connector.ConnectorNameExist")
                .subscribe((res: string) => {
                  this.connectorNameRequiredError = res;
                });
            }
          } else {
            this.connectorNameRequiredError = "";
            this.connectorIdentifierRequiredError = "";
            this.selectedIndex = 5;
          }
        }
      }
    }
    if (this.selectedIndex == 6) {
      if (this.clientId == "" || this.clientId == undefined) {
        this.translate
          .get("Connector.EnterClientId")
          .subscribe((res: string) => {
            this.clientIdRequiredError = res;
          });
        this.selectedIndex = 5;
      } else {
        this.clientIdRequiredError = "";
      }
      if (this.clientSecret == "" || this.clientSecret == undefined) {
        this.translate
          .get("Connector.EnterClientSecret")
          .subscribe((res: string) => {
            this.clientSecretRequiredError = res;
          });
        this.selectedIndex = 5;
      } else {
        this.clientSecretRequiredError = "";
      }
      if (this.clientId && this.clientSecret) {
        this.clientIdRequiredError = "";
        this.clientSecretRequiredError = "";
        this.selectedIndex = 6;
      }
    }
    if (this.selectedIndex == this.maxNumberOfTabs - 1) {
      this.nextButtonDisable = true;
      this.displayNext = "none";
      this.displayDone = "none";
      this.displayAddAnCon = "none";
      this.displaySubmit = "block";
    }
    if (this.onCloseModelHeader) {
      this.unCheckAllCheckbox(this.selectedCapabilities);
      this.unCheckAllCheckbox(this.selectedDeviceCapabilities);
    }
  }

  previousStep() {
    this.nextButtonDisable = false;
    this.displayNext = "block";
    this.displaySubmit = "none";
    if (this.selectedIndex != 0) {
      this.selectedIndex = this.selectedIndex - 1;
    }
    if (this.selectedIndex == 0) {
      this.backButtonDisable = true;
    }
    this.capabilityChecked();
  }

  onChangeCategory(e, cap) {
    if (this.selectedConnectorType != "IoT") {
      if (e.target.checked == true) {
        //console.log(cap.name)
        this.selectedCapabilities.push(cap.name);
      } else {
        if (this.selectedCapabilities.length > 0) {
          //console.log(cap.name)
          var index = this.selectedCapabilities.indexOf(cap.name);
          if (index > -1) {
            this.selectedCapabilities.splice(index, 1);
          }
        }
      }
    } else if (this.selectedConnectorType == "IoT") {
      if (e.target.checked == true) {
        //console.log(cap.name)
        this.selectedDeviceCapabilities.push(cap.name);
      } else {
        if (this.selectedDeviceCapabilities.length > 0) {
          //console.log(cap.name)
          var index = this.selectedDeviceCapabilities.indexOf(cap.name);
          if (index > -1) {
            this.selectedDeviceCapabilities.splice(index, 1);
          }
        }
      }
    }
  }

  closeModalDialog(id) {
    $("#" + id).modal("hide");
  }

  showModalDialog(id) {
    $("#" + id).modal("show");
  }

  addConnectorDone() {
    this.onCloseModelHeader();
  }
  async addConnectorDetails() {
    if (this.publicKey == "" || this.publicKey == undefined) {
      this.translate
        .get("Connector.EnterPublicKey")
        .subscribe((res: string) => {
          this.publicKeyRequiredError = res;
        });
    }
    if (this.publicKey) {
      let args = {
        developerId: this.userData.id,
        publicKey: this.publicKey,
      };
      let data = await this.validatePublicKey(args);
      if (data && data.status == false) {
        if (data.info == "invalid_public_key") {
          this.translate
            .get("Connector.InvalidKey")
            .subscribe((res: string) => {
              this.publicKeyRequiredError = res;
            });
        }
      } else {
        this.publicKeyRequiredError = "";
        //console.log('this.selectedCapabilities', this.selectedCapabilities)
        let params1 = {
          developerId: this.userData.id,
          endPoint: this.connectorEndpoint,
          capabilities:
            this.selectedConnectorType != "IoT"
              ? this.selectedCapabilities
              : this.selectedDeviceCapabilities,
          timeout: this.connectorTimeout,
          name: this.connectorName,
          identifier: this.connectorIdentifier,
          clientId: this.clientId,
          clientSecret: this.clientSecret,
          publicKey: this.publicKey,
          type: this.selectedConnectorType,
        };
        //console.log('params1', params1)
        this.connectorService
          .addConnectorDetails(params1)
          .subscribe((response) => {
            if (response && response.status == false) {
              this.toastr.error("", response.info);
            } else {
              //console.log('daatttaa', response.info)
              let sessionParams = {
                id: response.info.connectorId,
                name: this.connectorName,
              };
              let params = {
                developerId: this.userData.id,
              };
              localStorage.setItem(
                "connectorDetails",
                JSON.stringify(sessionParams)
              );
              if (this.selectedIndex != 0) {
                this.selectedIndex = this.selectedIndex + 1;
              }
              if (this.selectedIndex === 7) {
                this.displayNext = "none";
                this.displaySubmit = "none";
                this.displayDone = "block";
                this.displayAddAnCon = "block";
                this.displayPrev = "none";
              }
              this.getAllConnector(params);
            }
          });
      }
    }
  }

  unCheckAllCheckbox(listOfCheckBox) {
    listOfCheckBox.forEach((item) => {
      console.log(item, $("#" + item).prop("checked"));
      $("#" + item).prop("checked", false);
    });
  }

  addConnectorStarter() {
    this.selectedIndex = 0;
    this.unCheckAllCheckbox(this.selectedCapabilities);
    this.backButtonDisable = true;
    this.displayNext = "block";
    this.displaySubmit = "none";
    this.displayPrev = "block";
    this.nextButtonDisable = false;
    this.clientSecretRequiredError = "";
    this.connectorIdentifierRequiredError = "";
    this.connectorEndpoint = "";
    this.timeoutRequiredError = "";
    this.clientIdRequiredError = "";
    this.connectorNameRequiredError = "";
    this.endpointRequiredError = "";
    this.capabilityRequiredError = "";
    this.publicKeyRequiredError = "";
    this.selectedCapabilities = [];
    this.connectorTimeout = "";
    this.connectorName = "";
    this.connectorIdentifier = "";
    this.clientId = "";
    this.clientSecret = "";
    this.publicKey = "";
  }

  onCloseModelHeader() {
    this.selectedConnectorType = null;
    this.addConnectorStarter();
    this.closeModalDialog("addConnectorModal");
  }

  addAnotherConnector() {
    this.addConnectorStarter();
  }

  valueCheck(name, capabilities) {
    let checked = false;
    if (capabilities && capabilities[name]) {
      checked = true;
    }
    return checked;
  }

  checkedValueArray(e, cap) {
    if (this.connectorContent["capabilities"] == null) {
      this.connectorContent["capabilities"] = {};
    }
    if (e.target.checked == true) {
      this.connectorContent["capabilities"][cap.name] = true;
    } else {
      this.connectorContent["capabilities"][cap.name] = false;
    }
  }

  valueCheckDevice(name, capabilities) {
    let checked = false;
    if (capabilities && capabilities[name]) {
      checked = true;
    }
    return checked;
  }

  checkedDeviceValueArray(e, cap) {
    if (this.connectorContent["deviceCapabilities"] == null) {
      this.connectorContent["deviceCapabilities"] = {};
    }
    if (e.target.checked == true) {
      this.connectorContent["deviceCapabilities"][cap.name] = true;
    } else {
      this.connectorContent["deviceCapabilities"][cap.name] = false;
    }
  }

  async validateConnectorDetails(args) {
    let data = this.connectorService.validateConnectorDetails(args).toPromise();
    return data;
  }

  async validatePublicKey(args) {
    let data = this.connectorService.validatePublicKey(args).toPromise();
    return data;
  }

  deleteConnector() {
    this.translate
      .get("Connector.ConfirmDeleteConnector")
      .subscribe((res: string) => {
        this.delconfirmConnector = res;
      });
    if (confirm(this.delconfirmConnector)) {
      let args = {
        developerId: this.userData.id,
        connectorId: this.connectorContent["id"],
      };
      this.connectorService.deleteConnector(args).subscribe((data) => {
        if (data && data.status == false) {
          if (data.info == "connector_added_to_application") {
            this.translate
              .get("Connector.DeleteConnectorResponse")
              .subscribe((res: string) => {
                this.toastr.error("", res);
              });
          } else if (data.info == "server_issue") {
            this.translate
              .get("Application.SomethingWrong")
              .subscribe((res: string) => {
                this.toastr.error("", res);
              });
          } else {
            this.toastr.error("", data.info);
          }
        } else {
          localStorage.removeItem("connectorDetails");
          this.connectorContent = "";
          let params = {
            developerId: this.userData.id,
          };
          this.getAllConnector(params);
        }
      });
    }
  }

  async updateConnectorDetails() {
    let optionalParamsKeyArray = [];
    let optionalParamsValueArray = [];
    this.paramsArray.forEach(function (element, index) {
      optionalParamsKeyArray.push(element.key);
      optionalParamsValueArray.push(element.value);
    });
    this.selectedConnectorCapabilities = [];
    this.selectedDeviceCapabilities = [];
    if (this.connectorContent["capabilities"] != null || this.connectorContent["capabilities"] != undefined) {
      Object.keys(this.connectorContent["capabilities"]).forEach((key) => {
        if (this.connectorContent["capabilities"][key] == true) {
          this.selectedConnectorCapabilities.push(key);
        }
      });
    }
    if (this.connectorContent["deviceCapabilities"] != null || this.connectorContent["deviceCapabilities"] != undefined) {
      Object.keys(this.connectorContent["deviceCapabilities"]).forEach(
        (key) => {
          if (this.connectorContent["deviceCapabilities"][key] == true) {
            this.selectedDeviceCapabilities.push(key);
          }
        }
      );
    }
    if (this.selectedConnectorCapabilities.length == 0 && this.connectorContent.type !== 'IoT') {
      this.translate.get("Connector.EnterCapability").subscribe((res: string) => {
          this.connectorCapabilityRequiredError = res;
        });
    } else if (this.selectedDeviceCapabilities.length == 0 && this.connectorContent.type == 'IoT') {
      this.translate.get("Connector.EnterCapability").subscribe((res: string) => {
          this.connectorCapabilityRequiredError = res;
        });
    } else {
      this.connectorCapabilityRequiredError = "";
    }
    if (this.connectorContent["endPoint"] == "" || this.connectorContent["endPoint"] == undefined) {
      this.translate.get("Connector.EnterEndpoint").subscribe((res: string) => {
        this.updateendpointRequiredError = res;
      });
    }
    if (this.connectorContent["endPoint"] && this.validURL(this.connectorContent["endPoint"]) == false) {
      this.translate.get("Connector.EnterValidURL").subscribe((res: string) => {
        this.updateendpointRequiredError = res;
      });
    }
    // if (this.connectorContent['webhookUrl'] == '' || this.connectorContent['webhookUrl'] == null || this.connectorContent['webhookUrl'] == undefined) {
    // 	this.translate.get('Connector.EnterEndpoint').subscribe((res: string) => {
    // 		this.updateWebHookUrlRequiredError = res;
    // 	})
    // } else {
    if (this.connectorContent["webhookUrl"] && this.validURL(this.connectorContent["webhookUrl"]) == false) {
      this.translate.get("Connector.EnterValidURL").subscribe((res: string) => {
        this.updateWebHookUrlRequiredError = res;
      });
    } else {
      this.updateWebHookUrlRequiredError = "";
    }
    // }
    if (this.connectorContent["type"] === "" || this.connectorContent["type"] === undefined || this.connectorContent["type"] === null) {
      this.translate.get("Connector.SelectConnectorType").subscribe((res: string) => {
          this.updateConnectorTypeRequiredError = res;
        });
    } else {
      this.updateConnectorTypeRequiredError = "";
    }
    if (this.connectorContent["clientId"] == "" || this.connectorContent["clientId"] == undefined) {
      this.translate.get("Connector.EnterClientId").subscribe((res: string) => {
        this.updateclientIdRequiredError = res;
      });
    } else {
      this.updateclientIdRequiredError = "";
    }
    if (this.connectorContent["clientSecret"] == "" || this.connectorContent["clientSecret"] == undefined) {
      this.translate.get("Connector.EnterClientSecret").subscribe((res: string) => {
          this.updateclientSecretRequiredError = res;
        });
    } else {
      this.updateclientSecretRequiredError = "";
    }
    if (this.connectorContent["timeout"] == "" || this.connectorContent["timeout"] == undefined) {
      this.translate.get("Connector.EnterTimeout").subscribe((res: string) => {
        this.updatetimeoutRequiredError = res;
      });
    } else {
      this.updatetimeoutRequiredError = "";
    }
    if (this.connectorContent["publicKey"] == "" || this.connectorContent["publicKey"] == undefined) {
      this.translate.get("Connector.EnterPublicKey").subscribe((res: string) => {
          this.updatepublicKeyRequiredError = res;
        });
    }
    console.log(
      "if condition",
      (this.selectedConnectorCapabilities.length > 0 ||
        this.selectedDeviceCapabilities.length > 0) &&
        this.connectorContent["endPoint"] &&
        this.connectorContent["clientId"] &&
        this.connectorContent["clientSecret"] &&
        this.connectorContent["timeout"] &&
        this.connectorContent["publicKey"] &&
        this.connectorContent["type"] &&
        this.checkUpdateRequiredError() === true
    );
    if ((this.selectedConnectorCapabilities.length > 0 || this.selectedDeviceCapabilities.length > 0) && this.connectorContent["endPoint"] && this.connectorContent["clientId"] && this.connectorContent["clientSecret"] && this.connectorContent["timeout"] && this.connectorContent["publicKey"] && this.connectorContent["type"] && this.checkUpdateRequiredError() === true) {
      let args = {
        developerId: this.userData.id,
        publicKey: this.connectorContent["publicKey"],
      };
      let data = await this.validatePublicKey(args);
      if (data && data.status == false) {
        if (data.info == "invalid_public_key") {
          this.translate.get("Connector.InvalidKey").subscribe((res: string) => {
              this.updatepublicKeyRequiredError = res;
            });
        }
      } else {
        this.updatepublicKeyRequiredError = "";
        this.updateendpointRequiredError = "";
        this.updateWebHookUrlRequiredError = "";
        this.updateConnectorTypeRequiredError = "";
        let params = {
          developerId: this.userData.id,
          connectorId: this.connectorContent["id"],
          image: this.connectorContent.icon || this.previewUrl,
          endPoint: this.connectorContent["endPoint"],
          capabilities: this.selectedConnectorCapabilities,
          deviceCapabilities: this.selectedDeviceCapabilities,
          capabilityLimit: this.connectorContent["capabilityLimits"],
          timeout: this.connectorContent["timeout"],
          clientId: this.connectorContent["clientId"],
          clientSecret: this.connectorContent["clientSecret"],
          optionalParamsKey: optionalParamsKeyArray,
          optionalParamsValue: optionalParamsValueArray,
          publicKey: this.connectorContent["publicKey"],
          webhookUrl: this.connectorContent["webhookUrl"],
          type: this.connectorContent["type"],
        };

        //console.log('update params async issue',this.previewUrl);
        //console.log('update this.connectorContent.icon issue',this.connectorContent.icon );
        this.connectorService.updateConnectorDetails(params).subscribe((response) => {
          if (response && response.status == false) {
            this.toastr.error("", response.info);
          } else {
            this.translate.get("Connector.UpdateSuccess").subscribe((res: string) => {
                this.toastr.success("", res);
              });
            let connectorParams = {
              id: this.connectorContent["id"],
            };
            this.viewConnectorDetails(connectorParams);
            this.preview();
          }
        });
      }
    }
  }

  uploadImage(fileInput: any) {
    this.imageUploaded = true;
    this.fileData = <File>fileInput.target.files[0];
    this.preview();
  }

  preview() {
    // Show preview
    //console.log('this.fileData',this.fileData);
    if (this.fileData) {
      var mimeType = this.fileData.type;
      if (mimeType.match(/image\/*/) == null) {
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = (_event) => {
        //console.log('event',_event.target.result);
        this.contentData2 = _event.target.result;
        let args = {
          image: this.contentData2,
          connectorId: this.connectorContent["id"],
          developerId: this.userData.id,
        };

        if (this.contentData2) {
          this.connectorService.uploadConnectorIcon(args).subscribe((data) => {
            if (data && data.status) {
              //this.toastr.success('Connector icon is changed successfully');
            }
          });
          this.previewUrl = reader.result;
          //console.log('this.previewUrl',this.previewUrl);
        } else {
          this.previewUrl = this.connectorContent.icon
            ? this.connectorContent.icon
            : this.previewUrl;
        }
      };
    }
  }

  publishConnectorDetails() {
    let args = {
      developerId: this.userData.id,
      connectorId: this.connectorContent["id"],
      firstName: this.loggedUsername,
    };
    this.connectorService.publishConnectorDetails(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        this.translate
          .get("Connector.PublishSuccess")
          .subscribe((res: string) => {
            this.toastr.success("", res);
          });
        let connectorParams = {
          id: this.connectorContent["id"],
        };
        this.viewConnectorDetails(connectorParams);
      }
    });
  }

  cancelPublishRequest() {
    let args = {
      developerId: this.userData.id,
      connectorId: this.connectorContent["id"],
      firstName: this.loggedUsername,
    };
    this.connectorService.cancelPublishRequest(args).subscribe((data) => {
      if (data && data.status == false) {
        this.toastr.error("", data.info);
      } else {
        let connectorParams = {
          id: this.connectorContent["id"],
        };
        this.viewConnectorDetails(connectorParams);
      }
    });
  }

  async updatePublish() {
    let optionalParamsKeyArray = [];
    let optionalParamsValueArray = [];
    this.paramsArray.forEach(function (element, index) {
      optionalParamsKeyArray.push(element.key);
      optionalParamsValueArray.push(element.value);
    });
    this.selectedConnectorCapabilities = [];
    this.selectedDeviceCapabilities = [];
    Object.keys(this.connectorContent["capabilities"]).forEach((key) => {
      if (this.connectorContent["capabilities"][key] == true) {
        this.selectedConnectorCapabilities.push(key);
      }
    });
    if (
      this.connectorContent["deviceCapabilities"] != null ||
      this.connectorContent["deviceCapabilities"] != undefined
    ) {
      Object.keys(this.connectorContent["deviceCapabilities"]).forEach(
        (key) => {
          if (this.connectorContent["deviceCapabilities"][key] == true) {
            this.selectedDeviceCapabilities.push(key);
          }
        }
      );
    }
    if (this.selectedConnectorCapabilities.length == 0) {
      this.translate
        .get("Connector.EnterCapability")
        .subscribe((res: string) => {
          this.connectorCapabilityRequiredError = res;
        });
    } else {
      this.connectorCapabilityRequiredError = "";
    }
    if (
      this.connectorContent["endPoint"] == "" ||
      this.connectorContent["endPoint"] == undefined
    ) {
      this.translate.get("Connector.EnterEndpoint").subscribe((res: string) => {
        this.updateendpointRequiredError = res;
      });
    }
    if (
      this.connectorContent["endPoint"] &&
      this.validURL(this.connectorContent["endPoint"]) == false
    ) {
      this.translate.get("Connector.EnterValidURL").subscribe((res: string) => {
        this.updateendpointRequiredError = res;
      });
    }
    // if (this.connectorContent['webhookUrl'] == '' || this.connectorContent['webhookUrl'] == null || this.connectorContent['webhookUrl'] == undefined) {
    // 	this.translate.get('Connector.EnterEndpoint').subscribe((res: string) => {
    // 		this.updateWebHookUrlRequiredError = res;
    // 	})
    // } else {
    if (
      this.connectorContent["webhookUrl"] &&
      this.validURL(this.connectorContent["webhookUrl"]) == false
    ) {
      this.translate.get("Connector.EnterValidURL").subscribe((res: string) => {
        this.updateWebHookUrlRequiredError = res;
      });
    } else {
      this.updateWebHookUrlRequiredError = "";
    }
    // }
    if (
      this.connectorContent["type"] === "" ||
      this.connectorContent["type"] === undefined ||
      this.connectorContent["type"] === null
    ) {
      this.translate
        .get("Connector.SelectConnectorType")
        .subscribe((res: string) => {
          this.updateConnectorTypeRequiredError = res;
        });
    } else {
      this.updateConnectorTypeRequiredError = "";
    }
    if (
      this.connectorContent["clientId"] == "" ||
      this.connectorContent["clientId"] == undefined
    ) {
      this.translate.get("Connector.EnterClientId").subscribe((res: string) => {
        this.updateclientIdRequiredError = res;
      });
    } else {
      this.updateclientIdRequiredError = "";
    }
    if (
      this.connectorContent["clientSecret"] == "" ||
      this.connectorContent["clientSecret"] == undefined
    ) {
      this.translate
        .get("Connector.EnterClientSecret")
        .subscribe((res: string) => {
          this.updateclientSecretRequiredError = res;
        });
    } else {
      this.updateclientSecretRequiredError = "";
    }
    if (
      this.connectorContent["timeout"] == "" ||
      this.connectorContent["timeout"] == undefined
    ) {
      this.translate.get("Connector.EnterTimeout").subscribe((res: string) => {
        this.updatetimeoutRequiredError = res;
      });
    } else {
      this.updatetimeoutRequiredError = "";
    }
    if (
      this.connectorContent["publicKey"] == "" ||
      this.connectorContent["publicKey"] == undefined
    ) {
      this.translate
        .get("Connector.EnterPublicKey")
        .subscribe((res: string) => {
          this.updatepublicKeyRequiredError = res;
        });
    }
    if (
      this.selectedConnectorCapabilities.length > 0 &&
      this.connectorContent["endPoint"] &&
      this.connectorContent["clientId"] &&
      this.connectorContent["clientSecret"] &&
      this.connectorContent["timeout"] &&
      this.connectorContent["publicKey"] &&
      this.connectorContent["type"] &&
      this.checkUpdateRequiredError() === true
    ) {
      let args = {
        developerId: this.userData.id,
        publicKey: this.connectorContent["publicKey"],
      };
      let data = await this.validatePublicKey(args);
      if (data && data.status == false) {
        if (data.info == "invalid_public_key") {
          this.translate
            .get("Connector.InvalidKey")
            .subscribe((res: string) => {
              this.updatepublicKeyRequiredError = res;
            });
        }
      } else {
        this.updatepublicKeyRequiredError = "";
        this.updateendpointRequiredError = "";
        let params = {
          developerId: this.userData.id,
          connectorId: this.connectorContent["id"],
          image: this.connectorContent.icon
            ? this.connectorContent.icon
            : this.previewUrl,
          endPoint: this.connectorContent["endPoint"],
          capabilities: this.selectedConnectorCapabilities,
          deviceCapabilities: this.selectedDeviceCapabilities,
          capabilityLimit: this.connectorContent["capabilityLimits"],
          timeout: this.connectorContent["timeout"],
          clientId: this.connectorContent["clientId"],
          clientSecret: this.connectorContent["clientSecret"],
          optionalParamsKey: optionalParamsKeyArray,
          optionalParamsValue: optionalParamsValueArray,
          publicKey: this.connectorContent["publicKey"],
          firstName: this.loggedUsername,
          webhookUrl: this.connectorContent["webhookUrl"],
          type: this.connectorContent["type"],
        };

        //console.log('update params',this.previewUrl);
        //console.log('update this.connectorContent.icon ',this.connectorContent.icon );

        this.connectorService.updatePublish(params).subscribe((response) => {
          if (response && response.status == false) {
            this.toastr.error("", response.info);
          } else {
            let connectorParams = {
              id: this.connectorContent["id"],
            };
            this.viewConnectorDetails(connectorParams);
          }
        });
      }
    }
  }

  async cancelPublishUpdate() {
    let optionalParamsKeyArray = [];
    let optionalParamsValueArray = [];
    this.paramsArray.forEach(function (element, index) {
      optionalParamsKeyArray.push(element.key);
      optionalParamsValueArray.push(element.value);
    });
    let args = {
      developerId: this.userData.id,
      publicKey: this.connectorContent["publicKey"],
    };
    let data = await this.validatePublicKey(args);
    if (data && data.status == false) {
      if (data.info == "invalid_public_key") {
        this.translate.get("Connector.InvalidKey").subscribe((res: string) => {
          this.updatepublicKeyRequiredError = res;
        });
      } else if (data.info == "publicKey_parameter_missing") {
        this.translate
          .get("Connector.EnterPublicKey")
          .subscribe((res: string) => {
            this.updatepublicKeyRequiredError = res;
          });
      } else {
        this.updatepublicKeyRequiredError = "";
        this.toastr.error("", data.info);
      }
    } else {
      this.updatepublicKeyRequiredError = "";
      let params = {
        developerId: this.userData.id,
        connectorId: this.connectorContent["id"],
        endPoint: this.connectorContent["endPoint"],
        capabilities: this.selectedConnectorCapabilities,
        deviceCapabilities: this.selectedDeviceCapabilities,
        capabilityLimit: this.connectorContent["capabilityLimits"],
        timeout: this.connectorContent["timeout"],
        clientId: this.connectorContent["clientId"],
        clientSecret: this.connectorContent["clientSecret"],
        optionalParamsKey: optionalParamsKeyArray,
        optionalParamsValue: optionalParamsValueArray,
        publicKey: this.connectorContent["publicKey"],
        firstName: this.loggedUsername,
        webhookUrl: this.connectorContent["webhookUrl"],
        type: this.connectorContent["type"],
      };
      this.connectorService
        .cancelPublishUpdate(params)
        .subscribe((response) => {
          if (response && response.status == false) {
            this.toastr.error("", response.info);
          } else {
            let connectorParams = {
              id: this.connectorContent["id"],
            };
            this.viewConnectorDetails(connectorParams);
          }
        });
    }
  }

  capabilityChecked() {
    if (this.selectedConnectorType == "IoT") {
      if (this.selectedDeviceCapabilities.length > 0) {
        for (let scapability of this.selectedDeviceCapabilities) {
          for (let capability of this.deviceCapabilities) {
            if (capability.name == scapability) {
              capability.checked = true;
            } else {
              capability.checked = false;
            }
          }
        }
      } else {
        for (let capability of this.deviceCapabilities) {
          capability.checked = false;
        }
      }
    } else if (this.selectedConnectorType != "IoT") {
      if (this.selectedCapabilities.length > 0) {
        for (let scapability of this.selectedCapabilities) {
          for (let capability of this.capabilities) {
            if (capability.name == scapability) {
              capability.checked = true;
            } else {
              capability.checked = false;
            }
          }
        }
      } else {
        for (let capability of this.capabilities) {
          capability.checked = false;
        }
      }
    } else {
      //Do Nothing
    }
  }

  connectorTypeChange() {
    this.selectedCapabilities = [];
    this.selectedDeviceCapabilities = [];
    this.capabilityChecked();
  }
}
